import { useEffect} from "react";
import { userAuth } from "@auth";
import { GuestAccount } from "./user-auth";

// load the encryption library
const bcrypt = require('bcryptjs');

// load a library to upgrade to a secure random number generator
import isaac from "isaac";

/**
 *  override the unsecure math.random when generating hashes
 */
bcrypt.setRandomFallback((len) => {
    // create an array with size defined
    const buf = [...new Uint8Array(len)];

    // assign a new random number generator
    return buf.map(() => Math.floor(isaac.random() * 256));
});

/**
 * page to collect the user credentials and verify them
 *
 * @returns React.ReactElement
 * @constructor
 */
export const Bypass = () => {

    // methods to log into to the app and redirect to the main page
    const { login } = userAuth();

    useEffect(() => {
        login(GuestAccount);
    }, []);

    return null;
};